<!--Header-->
<div class="modal-header">
    <div class="col-md-12 col-sm-12 col-12">
      <div class="row">
        <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
          <h4 class="modal-title"><span id="ApntmntHdr">Select {{ isCust ? 'Customer' : 'Supplier'}}</span></h4>
        </div>
        <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
          <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="passBack()"></i>
        </div>
      </div>
    </div>
  </div>
  <!--Body-->
  <div class="modal-body" style="padding-top: 10px;">
    <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
      <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; padding: 0px;">
        <!-- <select *ngIf="isCust" class="label Bluebadge form-control" [(ngModel)]="selected.id" style="display: inline-block; font-size: 14px; background: inherit;">
          <option value="0" selected disabled>Select</option>
          <option *ngFor="let c of customers" [ngValue]="c.RelativeID">{{c.CompanyName}}</option>  
        </select> -->
        <div *ngIf="isCust">
          <div *ngIf="!compRules.isB2C">
              <input class="form-control" list="custmer" [(ngModel)]="selected.id" (blur)="checkValidCust()" tabindex="1" placeholder="Select">
              <datalist id="custmer">                        
                  <option *ngFor="let c of customers" [value]="c.Cmp">
                    {{compRules.isB2C ? (c.Cmp == '-' ? c.Name : c.Cmp + ' / ' + c.Name) : c.Cmp}} 
                  </option>
              </datalist>
          </div>
        <div *ngIf="compRules.isB2C">
          <select class="label Bluebadge form-control bgwhite bdrrd10" [(ngModel)]="selected.id"  ng-change="checkValidCust()"
            style="display: inline-block; font-size: 13px; background: inherit; cursor: pointer;">
            <option value="">Select Customer</option>
            <option *ngFor="let c of customers" [value]="c.Cmp">
              {{compRules.isB2C ? (c.Cmp == '-' ? c.Name : c.Cmp + ' / ' + c.Name) : c.Cmp}} 
            </option>
          </select>
        </div>

        </div>
        

        <!-- <select *ngIf="!isCust" class="label Bluebadge form-control" [(ngModel)]="selected.id" style="display: inline-block; font-size: 14px; background: inherit;">
          <option value="0" selected disabled>Select</option>  
          <option *ngFor="let s of suppliers" [ngValue]="s.RelativeID">{{s.CompanyName}}</option>  
        </select> -->

        <div *ngIf="!isCust">
          <input class="form-control" list="sup" [(ngModel)]="selected.id" tabindex="1" (blur)="checkValidCust()" placeholder="Select">
          <datalist id="sup">                        
              <option *ngFor="let s of suppliers" [value]="s.Cmp">{{s.Cmp}}</option>
          </datalist>
        </div>
      </div>
    </div>
  </div>
  <!--Footer-->
    <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
        <span class="btn btn-save brdrRadius3" style="padding: 2px 10px 2px; line-height: 25px;" (click)="save()">
        <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
        <span>Select</span>
        </span>
    </div>
